import React from 'react';
import { useTranslation } from './i18n';

export default function PrivacyPage({ onBack }) {
  const { t } = useTranslation();

  const sections = [
    {
      title: t('privacy_page.sections.who_we_are.title'),
      body: [t('privacy_page.sections.who_we_are.body')],
      extraLabel: t('privacy_page.sections.who_we_are.contact_label'),
      bullets: [
        t('privacy_page.sections.who_we_are.contact_email'),
        t('privacy_page.sections.who_we_are.contact_website'),
      ],
    },
    {
      title: t('privacy_page.sections.what_we_do.title'),
      body: [t('privacy_page.sections.what_we_do.body')],
      bullets: [
        t('privacy_page.sections.what_we_do.item_1'),
        t('privacy_page.sections.what_we_do.item_2'),
        t('privacy_page.sections.what_we_do.item_3'),
      ],
    },
    {
      title: t('privacy_page.sections.data_processed.title'),
      subsections: [
        {
          title: t('privacy_page.sections.data_processed.candidates_title'),
          bullets: [
            t('privacy_page.sections.data_processed.candidates_1'),
            t('privacy_page.sections.data_processed.candidates_2'),
            t('privacy_page.sections.data_processed.candidates_3'),
            t('privacy_page.sections.data_processed.candidates_4'),
            t('privacy_page.sections.data_processed.candidates_5'),
            t('privacy_page.sections.data_processed.candidates_6'),
            t('privacy_page.sections.data_processed.candidates_7'),
          ],
        },
        {
          title: t('privacy_page.sections.data_processed.employers_title'),
          bullets: [
            t('privacy_page.sections.data_processed.employers_1'),
            t('privacy_page.sections.data_processed.employers_2'),
            t('privacy_page.sections.data_processed.employers_3'),
            t('privacy_page.sections.data_processed.employers_4'),
          ],
        },
        {
          title: t('privacy_page.sections.data_processed.technical_title'),
          bullets: [
            t('privacy_page.sections.data_processed.technical_1'),
            t('privacy_page.sections.data_processed.technical_2'),
          ],
        },
      ],
    },
    {
      title: t('privacy_page.sections.purposes.title'),
      bullets: [
        t('privacy_page.sections.purposes.item_1'),
        t('privacy_page.sections.purposes.item_2'),
        t('privacy_page.sections.purposes.item_3'),
        t('privacy_page.sections.purposes.item_4'),
        t('privacy_page.sections.purposes.item_5'),
        t('privacy_page.sections.purposes.item_6'),
      ],
    },
    {
      title: t('privacy_page.sections.legal_basis.title'),
      body: [t('privacy_page.sections.legal_basis.body')],
      bullets: [
        t('privacy_page.sections.legal_basis.item_1'),
        t('privacy_page.sections.legal_basis.item_2'),
        t('privacy_page.sections.legal_basis.item_3'),
        t('privacy_page.sections.legal_basis.item_4'),
      ],
    },
    {
      title: t('privacy_page.sections.ai_profiling.title'),
      body: [t('privacy_page.sections.ai_profiling.body'), t('privacy_page.sections.ai_profiling.rights_intro')],
      bullets: [
        t('privacy_page.sections.ai_profiling.item_1'),
        t('privacy_page.sections.ai_profiling.item_2'),
        t('privacy_page.sections.ai_profiling.item_3'),
        t('privacy_page.sections.ai_profiling.item_4'),
        t('privacy_page.sections.ai_profiling.right_1'),
        t('privacy_page.sections.ai_profiling.right_2'),
      ],
    },
    {
      title: t('privacy_page.sections.sharing.title'),
      body: [t('privacy_page.sections.sharing.body'), t('privacy_page.sections.sharing.outro')],
      bullets: [
        t('privacy_page.sections.sharing.item_1'),
        t('privacy_page.sections.sharing.item_2'),
        t('privacy_page.sections.sharing.item_3'),
        t('privacy_page.sections.sharing.item_4'),
      ],
    },
    {
      title: t('privacy_page.sections.international_transfers.title'),
      body: [t('privacy_page.sections.international_transfers.body')],
    },
    {
      title: t('privacy_page.sections.retention.title'),
      bullets: [
        t('privacy_page.sections.retention.item_1'),
        t('privacy_page.sections.retention.item_2'),
        t('privacy_page.sections.retention.item_3'),
      ],
    },
    {
      title: t('privacy_page.sections.security.title'),
      body: [t('privacy_page.sections.security.body')],
      bullets: [
        t('privacy_page.sections.security.item_1'),
        t('privacy_page.sections.security.item_2'),
        t('privacy_page.sections.security.item_3'),
      ],
    },
    {
      title: t('privacy_page.sections.rights.title'),
      body: [t('privacy_page.sections.rights.body')],
      bullets: [
        t('privacy_page.sections.rights.item_1'),
        t('privacy_page.sections.rights.item_2'),
        t('privacy_page.sections.rights.item_3'),
        t('privacy_page.sections.rights.item_4'),
        t('privacy_page.sections.rights.item_5'),
        t('privacy_page.sections.rights.item_6'),
      ],
      linkLabel: t('privacy_page.sections.rights.request_via_label'),
      linkHref: 'mailto:info@betaaldsolliciteren.nl',
      linkText: 'info@betaaldsolliciteren.nl',
    },
    {
      title: t('privacy_page.sections.pilot.title'),
      body: [t('privacy_page.sections.pilot.body')],
      bullets: [
        t('privacy_page.sections.pilot.item_1'),
        t('privacy_page.sections.pilot.item_2'),
        t('privacy_page.sections.pilot.item_3'),
      ],
    },
    {
      title: t('privacy_page.sections.cookies.title'),
      body: [t('privacy_page.sections.cookies.body')],
    },
    {
      title: t('privacy_page.sections.changes.title'),
      body: [t('privacy_page.sections.changes.body')],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logozondertekst.png" alt="Logo" className="h-8" />
            <span className="font-bold text-gray-900">WeRepresent</span>
          </div>
          <button
            onClick={onBack}
            className="text-gray-600 hover:text-gray-900 transition-colors"
          >
            {t('privacy_page.back_home')}
          </button>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('privacy_page.title')}</h1>
        <p className="text-gray-500 mb-8">{t('privacy_page.version')}</p>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6 text-gray-700">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">{section.title}</h2>
              {section.body?.map((paragraph) => (
                <p key={paragraph} className="mt-3 first:mt-0">{paragraph}</p>
              ))}
              {section.extraLabel ? <p className="mt-3 font-medium">{section.extraLabel}</p> : null}
              {section.bullets?.length ? (
                <ul className="mt-2 ml-4 list-disc space-y-1">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
              {section.subsections?.map((subsection) => (
                <div key={subsection.title} className="mt-4">
                  <h3 className="font-medium text-gray-800 mb-2">{subsection.title}</h3>
                  <ul className="ml-4 list-disc space-y-1">
                    {subsection.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              ))}
              {section.linkLabel ? (
                <p className="mt-3">
                  {section.linkLabel}{' '}
                  <a href={section.linkHref} className="text-blue-600 hover:underline">
                    {section.linkText}
                  </a>
                </p>
              ) : null}
            </section>
          ))}
        </div>
      </main>

      <footer className="bg-gray-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 text-center text-gray-400 text-sm">
          {t('privacy_page.footer', { year: new Date().getFullYear() })}
        </div>
      </footer>
    </div>
  );
}
